<template>
  <div>
    <video
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
    ></video>
  </div>
</template>
<script>
  import videojs from 'video.js'
  import 'video.js/dist/video-js.css'
  import { Toast } from 'vant'
  export default {
    name: 'VideoPlayer',
    props: {
      options: {
        type: Object,
        default() {
          return {}
        },
      },
      data: {
        type: Object,
        default() {
          return {}
        },
      },
      // 是否强制完播 为true时没有进行一次完整播放时禁止拖动播放
      isMustPlay: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        player: null,
      }
    },
    mounted() {
      this.player = videojs(this.$refs.videoPlayer, this.options, () => {
        this.player.init = false
        this.player.oldPlayTime = null
        // this.player.log('onPlayerReady', this)
        this.player.on('play', (e) => {
          this.$emit('play', e)
        })
        this.player.on('pause', (e) => {
          const currentTime = this.player.currentTime()
          this.$emit('pause', {
            $event: e,
            currentTime,
          })
        })
        this.player.on('ended', (e) => {
          this.$emit('ended', {
            $event: e,
            currentTime: this.player.currentTime(),
          })
        })
        this.player.on('waiting', (e) => {
          this.$emit('waiting', e)
        })
        // this.player.on('playing', (e) => {
        //   this.$emit('playing', e)
        // })
        this.player.on('timeupdate', (e) => {
          /**
           * 禁止拖动 当设置了强制完播的视频 且没看完一次的时候才禁止拖动
           */
          if (
            this.player.currentTime() - this.player.oldPlayTime > 2 && //跳跃超过2s 说明是在拖动
            this.player.oldPlayTime && // 说明oldPlayTime已经初始化了
            this.isMustPlay && // 是否强制完播
            !this.data.Completed // 当前视频是否进行过一次完整播放
          ) {
            Toast('首次学习不支持跳跃，请耐心学完哦')
            this.player.currentTime(this.player.oldPlayTime)
          } else {
            this.player.oldPlayTime = this.player.currentTime()
          }
          // 播放到了剩余小于等于15s就默认它已经播放完了
          if (this.player.currentTime() >= this.player.duration() - 15) {
            this.$emit('playCompleted', {
              $event: e,
              currentTime: this.player.currentTime(),
            })
          }
          this.$emit('timeupdate', {
            $event: e,
            currentTime: this.player.currentTime(),
          })
        })

        // this.player.on('loadeddata', (e) => {
        //   this.$emit('loadeddata', e)
        // })
        this.player.on('canplay', (e) => {
          // 跳转至播放记录
          if (!this.player.init) {
            this.player.currentTime(this.options.currentTime)
            // setTimeout(() => {
            this.player.init = true
            // }, 3000)
          }
          this.$emit('canplay', e)
        })
        this.player.on('canplaythrough', (e) => {
          this.$emit('canplaythrough', e)
        })
        this.player.on('statechanged', (e) => {
          this.$emit('statechanged', e)
        })
        this.player.on('ready', (e) => {
          this.$emit('ready', e)
        })
      })
    },
    beforeUnmount() {
      if (this.player) {
        this.player.dispose()
      }
    },
    methods: {
      pause() {
        if (this.player) {
          this.player.pause()
        }
      },
      setCurrentTime(time) {
        if (this.player) {
          this.player.currentTime(time)
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .video-js {
    width: 100%;
    height: 200px;
  }
</style>
